import { call, put, takeEvery } from "redux-saga/effects";
import { donHangApi } from "../../../api/don-hang/donHangApi";
import { IBaseRespone } from '../../../model/respone/IBaseRespone';
import { ISendEmailRequest } from "../../../model/request/don-hang/SendEmailRequest";
import { eDonHangActionTypeIds, IDonHangActions } from "../../action-types/don-hang/IDonHangActions";
import { donHangActions } from "../../actions/don-hang/donHangActions";

export function* sendEmailSaga(): any {
    yield takeEvery(eDonHangActionTypeIds.SEND_EMAIL_START, sendEmailWorker)
}

function* sendEmailWorker(action: IDonHangActions): any {
    const payload = action.payload as ISendEmailRequest;

    try {
        const res: IBaseRespone = yield call(donHangApi.SendEmail, payload);

        if (res.is_success) {
            yield put(donHangActions.SEND_EMAIL_SUCCESS({}));
        } else {
            yield put(donHangActions.SEND_EMAIL_ERROR(res.message ?? "Có lỗi xảy ra khi gửi email"));
        }
    } catch (error: any) {
        yield put(donHangActions.SEND_EMAIL_ERROR(error.message ?? "Có lỗi xảy ra khi gửi email"));
    }
}
